import LocalizedStrings from 'react-localization';
export default new LocalizedStrings({
    en: {
        // Loading status messages
        loadingValidatingToken: 'Validating authentication...',
        loadingAcquiringGps: 'Acquiring GPS location...',
        loadingStartingEncryption: 'Starting encryption with server...',
        loadingPerformingEncryption: 'Encrypting files...',
        loadingFinishingEncryption: 'Finalizing encryption...',
        // Error messages
        errorNoAccount: 'No account selected for encryption',
        errorControllerNotAvailable: 'Controller not available for API calls',
        errorTokenValidationFailed: 'Token validation failed',
        errorGpsAcquisitionFailed: 'Failed to acquire GPS location',
        errorEncryptionStartFailed: 'Failed to start encryption',
        errorEncryptionPerformFailed: 'Failed to perform encryption',
        errorEncryptionFinishFailed: 'Failed to finish encryption',
        errorManualLoginRequired: 'Manual authentication required before encryption',
        errorNoValidToken: 'No valid token available',
        errorSaveOperationCancelled: 'Save operation cancelled by user',
        errorNoStartResponse: 'No start response available from server',
        errorMissingRequiredData: 'Missing required data for finishing encryption',
        errorServerError: 'Server error:',
        // Success messages
        successEncryptionCompleted: 'Encryption completed successfully',
        // Vault settings descriptions
        vaultSettingsAllowCopy: 'Allow copying',
        vaultSettingsAllowPrint: 'Allow printing',
        vaultSettingsAllowSave: 'Allow saving',
        vaultSettingsAllowForward: 'Allow forwarding',
        vaultSettingsEnableDecryptReceipts: 'Enable decrypt receipts',
        vaultSettingsAuthorizedUsers: 'Authorized users',
        vaultSettingsCountries: 'Countries',
        vaultSettingsSunriseDate: 'Sunrise date',
        vaultSettingsSunsetDate: 'Sunset date',
        vaultSettingsNotes: 'Notes',
        // File encryption messages
        fileEncryptionInProgress: 'Encrypting files...',
        fileEncryptionCompleted: 'File encryption completed',
        fileEncryptionFailed: 'File encryption failed',
        fileSaveDialogTitle: 'Save Encrypted Vault',
        fileSaveDialogMessage: 'Choose where to save your encrypted vault'
    }
});
